/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import baseUrl from "../../BaseUrl";
import Loader from "../../Loader";
import { useNavigate, Link } from 'react-router-dom';
import Modal from 'react-modal';

const Step2 = ({ token, formData, setFormData  }) => {
   
    const navigate = useNavigate();
    
    const [popupOpen, setPopupOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState({}); 
    const [validationErrors, setValidationErrors] = useState([]);
    const [selectedPolicy, setSelectedPolicy] = useState("");
    const [trunkRouteName, setTrunkRouteName] = useState([]);
    const [orderNumberType, setOrderNumberType] = useState(0);
    const [selectedMobile, setSelectedMobile] = useState(null);
    const [dataArray, setDataArray] = useState([]);
    const [routingList, setRoutingList] = useState([]);
    const [routeList, setRouteList] = useState([]);
    const [trunkRouteList, setTrunkRouteList] = useState([]);
    const [nullMessge, setNullMessge] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [routeSwitch, setRouteSwitch] = useState(0);
    const [trunkIdCount, setTrunkIdCount] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [assignedRoutingOptions, setAssignedRoutingOptions] = useState({});
    const [routeOptionDisabled, setRouteOptionDisabled] = useState(false);
    const [selectedRoutingOption, setSelectedRoutingOption] = useState('');
    const [selectedRoutingOptionName, setSelectedRoutingOptionName] = useState('');
    const [selectedRoutingOptionId, setSelectedRoutingOptionId] = useState('');
    const [tableData, setTableData] = useState( [
        {
          selectedOption: '',
          inputText: '',
          yesNo: '',
          
        },
        {
          selectedOption: '',
          inputText: '',
          yesNo: '',
          
        },
        {
            selectedOption: '',
            inputText: '',
            yesNo: '',
            
        },
        {
            selectedOption: '',
            inputText: '',
            yesNo: '',
            
        },
        {
            selectedOption: '',
            inputText: '',
            yesNo: '',
           
        },
        {
            selectedOption: '',
            inputText: '',
            yesNo: '',
           
        },
        {
            selectedOption: '',
            inputText: '',
            yesNo: '',
           
        }
    ]);
    
    
    const openModal = (item) => {
        setShowModal(true);
        setCurrentItem(item);
    };
    const closeModal = () => {
        setShowModal(false);
        setValidationErrors([]);
    };
    
    useEffect(() => {
        if(token){
            getTrunkName();
            getRoutingOption();
        }
    }, [token]);

    // =========  based on number list check number type DID/TFN ============
    useEffect(() => {
        const counts = formData.importNumberList.reduce((acc, curr) => {
            acc[curr.number_type] = (acc[curr.number_type] || 0) + 1;
            return acc;
        }, {});
        const result = counts[0] && counts[1] ? 2 : counts[0] ? 0 : 1;
        setOrderNumberType(result);
    }, [formData.importNumberList]);

    useEffect(() => {
        
        console.log(formData.routePath, "change");
    }, [formData.routePath]);

    // =========  based on selected number validation for single number ============
    useEffect(() => {
        // Validate formData.routePath whenever it changes
        if (formData.routePath && formData.routePath.length > 0) {
            
            const errors = validateFormData(formData);
            setValidationErrors(errors);
          
            if (selectedMobile) {           
                const filteredErrorsArray = errors.filter(error => error.includes(selectedMobile));
                setValidationErrors(filteredErrorsArray);
        
                setShowModal(filteredErrorsArray.length > 0);
            }else {        
                setValidationErrors(errors);
                setShowModal(errors.length > 0);        
            }
        }
    }, [formData.routePath, selectedMobile]);

    // =========  based on selected number set route_option, route_id , route_name for single number ============
    useEffect(() => {       
        if(formData.routePath && formData.routePath.length > 0 && selectedMobile){

            const tableData = formData.routePath.find((item) => item[selectedMobile]?.tableData) ?. [selectedMobile]?.tableData || null;
            // console.log(tableData);
            if(tableData){
                console.log(tableData);
                // const targetValue =  tableData[0].selectedOption;
                // const selected = trunkRouteName.find((item) => item.value.includes(targetValue))?.name;
               
                
     
                const selectedRoutes = tableData.filter((val) => val.selectedOption != "")
                    .map((item) => {
                        // Find the name in trunkRouteName based on the selectedOption in tableData
                        const selected = trunkRouteName.find((route) => route.value.includes(item.selectedOption))?.name;
                    
                        // Find the route in routingList based on the selected name
                        const routeDetails = routingList.find((element) => element.value === selected);
                    
                        // Return an object with value, name, and id if routeDetails exists
                        return routeDetails
                            ? {
                                value: routeDetails.value,
                                name: routeDetails.name,
                                id: routeDetails.id
                            }
                            : null; // If not found, return null
                    }); 

                const route_option = selectedRoutes.map((val) => val.value).join(",");
                const route_name = selectedRoutes.map((val) => val.name).join(",");
                const route_id = selectedRoutes.map((val) => val.id).join(",");
                
                const index = formData.importNumberList.findIndex((item) => item.tn_number == selectedMobile);
                if (index !== -1) {
                    // Update the existing item
                    formData.importNumberList[index] = {
                        ...formData.importNumberList[index],
                        route_option,
                        route_name,
                        route_id,
                    };
                } else {
                    // Add a new item if the tn_number is not found
                    formData.importNumberList.push({
                        tn_number: selectedMobile,
                        route_option,
                        route_name,
                        route_id,
                    });
                }
            }
        }
      
    },[formData.routePath,selectedMobile]);

    // =========  set tabledata and policy based on selected number , if not assign then display blank ============
    useEffect(() => {
        if (formData.routePath && currentItem.tn_number) {
            // Check if currentItem.telephoneNumber is in formData.routePath
            const foundItem = formData.routePath.find(
                (item) => Object.keys(item)[0] == currentItem.tn_number
            );
    
            // Set selectedPolicy based on the check
            setSelectedPolicy(foundItem ? foundItem[currentItem.tn_number].policy : '');
            setTableData(foundItem ? foundItem[currentItem.tn_number].tableData : [
                {
                  selectedOption: '',
                  inputText: '',
                  yesNo: '',
                  
                },
                {
                  selectedOption: '',
                  inputText: '',
                  yesNo: '',
                  
                },
                {
                    selectedOption: '',
                    inputText: '',
                    yesNo: '',
                    
                },
                {
                    selectedOption: '',
                    inputText: '',
                    yesNo: '',
                    
                },
                {
                    selectedOption: '',
                    inputText: '',
                    yesNo: '',
                    
                },
                {
                    selectedOption: '',
                    inputText: '',
                    yesNo: '',
                    
                },
                {
                    selectedOption: '',
                    inputText: '',
                    yesNo: '',
                    
                }
            ]);
        }

    }, [formData.routePath, currentItem.tn_number]);

    // =========  check trunk assign for number and if assign then consider validtrunk ============
    useEffect(() => {
        
        formData.importNumberList.forEach(item => {
            const phoneNumber = item.tn_number;
            const matchingRoute = formData.routePath && formData.routePath.find(route => route.hasOwnProperty(phoneNumber));
           
            if (!matchingRoute) {
                item.validTrunk = false;
              return;
            }
        
            const routeData = matchingRoute[phoneNumber];
            
            if (routeData.policy == "1") {
                
                item.validTrunk = routeData.tableData.some(item => item.selectedOption !== "");
            } else if (routeData.policy === "2") {
              const hasSelectedOption = routeData.tableData.some(item => item.selectedOption !== "");
              const hasPercentageValues = routeData.tableData.some(item => item.inputText !== "" && Number(item.inputText) > 0);
              const sumOfPercentageValues = routeData.tableData.reduce((sum, item) => sum + Number(item.inputText), 0);

                item.validTrunk = hasSelectedOption && hasPercentageValues && sumOfPercentageValues === 100;
            } else {
                
                item.validTrunk = false;
            }
          });
         
    },[formData.routePath, formData.importNumberList]);

    // =========  check bandwidth did / bandwidth toll free route assign for customer or not ============
    useEffect(() => {
        if(routingList.length > 0 && formData.importNumberList){

        const hasNullValue = routingList.some(obj => obj.bandwidth_did === null || obj.bandwidth_toll_free === null);
            const checkNumberType = formData.importNumberList.some(item => item.number_type == 1);
            if(hasNullValue && checkNumberType){
                setNullMessge(true);
            }else{
                setNullMessge(false);
            }
        }
    }, [formData.importNumberList, routingList])

    // =========  Filter routing list based on selected rows ============
    useEffect(() => {
        if(selectedRows.length){

            const filteredData = formData.importNumberList.filter(obj => selectedRows.includes(obj.tn_number));
            const counts = filteredData.reduce((acc, curr) => {
                acc[curr.number_type] = (acc[curr.number_type] || 0) + 1;
                return acc;
            }, {});
            const result = counts[0] && counts[1] ? 2 : counts[0] ? 0 : 1;

            const updateRoute = routeList.filter((obj) => {
                if(result == 0){
                    return obj.did_access == 1;
                }else if(result == 1){
                    return obj.toll_free_access == 1;
                }else if(result == 2){
                    return obj.did_access == 1 && obj.toll_free_access == 1;
                }
            });

            setRoutingList(updateRoute);

        }

    }, [selectedRows, formData.importNumberList, routeList]);

    // =========  Switch off: Set route path as per selected route option ============
    useEffect(() => {
        if(Object.keys(assignedRoutingOptions).length > 0 && trunkRouteList.length > 0 && routeSwitch == 0){
            const updatedArray = [];
            formData.importNumberList.forEach((item) => {
                if (item.tn_number in assignedRoutingOptions) {
                    const value = assignedRoutingOptions[item.tn_number];

                    const matchingEntry = trunkRouteList.find(entry => entry.name === value);
                    if (matchingEntry) {

                        const newTableData = tableData.map((tableItem, index) => {
                            if (index === 0) {
                                return {
                                    ...tableItem,
                                    selectedOption: matchingEntry.value.toString(),
                                    inputText: '',
                                    yesNo: '1',
                                };
                            }
                            return tableItem;
                        });

                        const newData = {
                            policy: "1",
                            tableData: newTableData,
                        };
                        const objectToAdd = {};
                        objectToAdd[item.tn_number] = {...newData};

                        updatedArray.push(objectToAdd);

                    }
                }
            });

            setDataArray(prevDataArray => {
                const newDataArray = [...prevDataArray];

                updatedArray.forEach(updatedItem => {
                  const key = Object.keys(updatedItem)[0];
                  const existingIndex = newDataArray.findIndex(item => Object.keys(item)[0] === key);

                  if (existingIndex !== -1) {
                    newDataArray[existingIndex][key] = updatedItem[key];
                  } else {
                    newDataArray.push(updatedItem);
                  }
                });

                return newDataArray;
              });

            setFormData(prevFormData => {
                const existingRoutePath = Array.isArray(prevFormData.routePath) ? prevFormData.routePath : [];
                const newRoutePath = existingRoutePath.map(existingItem => {
                  const key = Object.keys(existingItem)[0];
                  const updatedItem = updatedArray.find(item => Object.keys(item)[0] === key);

                  return updatedItem ? { [key]: updatedItem[key] } : existingItem;
                });

                updatedArray.forEach(updatedItem => {
                  const key = Object.keys(updatedItem)[0];
                  if (!newRoutePath.some(existingItem => Object.keys(existingItem)[0] === key)) {
                    newRoutePath.push(updatedItem);
                  }
                });

                return { ...prevFormData, routePath: newRoutePath };
              });

        }

    },[formData.importNumberList, routeSwitch, assignedRoutingOptions])

    const getTrunkName = async () => {

            const counts = formData.importNumberList && formData.importNumberList.reduce((acc, curr) => {
                acc[curr.number_type] = (acc[curr.number_type] || 0) + 1;
                return acc;
            }, {});
            const result = counts[0] && counts[1] ? 2 : counts[0] ? 0 : 1;
        const response = await axios.get(`${baseUrl}/get-trunk-name/${formData.company_id}?type=${result}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const allArray = response.data;

        setTrunkRouteName(allArray.data);
        setTrunkRouteList(allArray.data);

    }

    // =========  Auto-select single routing option ============
    useEffect(() => {
        if(routeList.length === 1){
            setTrunkIdCount(true);
            setSelectedRoutingOption(routeList[0].value);
            setSelectedRoutingOptionName(routeList[0].name);
            setSelectedRoutingOptionId(routeList[0].id);
            const e = new Event("click");
            handleSelectAll(e);
        }else{
            setTrunkIdCount(false);
        }
    }, [routeList]);

    // =========  Auto-assign routing when only 1 trunk ============
    useEffect(() => {
        if(trunkIdCount && trunkRouteName.length > 0){
            console.log("Auto-assigning routing for single trunk");
            handleDefaultSet();
        }
    },[trunkRouteName, trunkIdCount])

    const getRoutingOption = async () => {
        try {

            const counts = formData.importNumberList.reduce((acc, curr) => {
                acc[curr.number_type] = (acc[curr.number_type] || 0) + 1;
                return acc;
            }, {});
            const result = counts[0] && counts[1] ? 2 : counts[0] ? 0 : 1;
            setPopupOpen(true);
            const response = await axios.get(`${baseUrl}/route-list/${formData.company_id}?type=${result}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const allArray = response.data;
        if(allArray.statusCode == 200){
            setRouteSwitch(allArray.switch || 0);
            setRoutingList(allArray.data);
            setRouteList(allArray.data);
        }
        setPopupOpen(false);

        } catch (error) {
            setPopupOpen(false);
           console.log(error);

        }
    };

    const handleRowChange = (e, index, fieldName) => {
        const newValue = e.target.value;

        setTableData((prevData) => {
            const updatedData = prevData.map((row, rowIndex) => {
                if (rowIndex === index) {
                    return {
                        ...row,
                        [fieldName]: newValue

                    };
                }
                return row;
            });
            return updatedData;
        });
    };

    // =========  Toggle individual row selection ============
    const handleToggleSelect = (tn_number) => {
        const updatedSelectedRows = selectedRows.includes(tn_number)
        ? selectedRows.filter((num) => num !== tn_number)
        : [...selectedRows, tn_number];

        if(updatedSelectedRows.length > 0){
            setRouteOptionDisabled(true);
        }else{
            setRouteOptionDisabled(false);
        }
        setSelectedRows(updatedSelectedRows);
    };

    // =========  Select all numbers for routing assignment ============
    const handleSelectAll = (e) => {
        e.preventDefault();
        let selectRows = [];
        if(routeList[0].did_access == 1 && routeList[0].toll_free_access == 2){
            selectRows = formData.importNumberList.filter(item => item.number_type === 0).map(item => item.tn_number);
        }else if(routeList[0].toll_free_access == 1 && routeList[0].did_access == 2){
            selectRows = formData.importNumberList.filter(item => item.number_type === 1).map(item => item.tn_number);
        }else{
            selectRows = formData.importNumberList.map(item => item.tn_number)
        }
        console.log(selectRows, "selectRows");
        setSelectedRows(selectRows);
    };

    // =========  Toggle select all checkbox ============
    const handleSwitchSelectAll = () => {
        if (selectAll) {
            setSelectedRows([]);
            setRouteOptionDisabled(false);
        } else {
            setSelectedRows(formData.importNumberList.map(item => item.tn_number));
            setRouteOptionDisabled(true);
        }

        setSelectAll(!selectAll);
    };

    // =========  Assign routing option to selected numbers ============
    const handleAssignRoutingOption = (e) => {
        e.preventDefault();

        if (!selectedRoutingOption) {
            alert("Please select routing option")
            return;
        }
        if (selectedRows.length === 0) {
            alert("Please select at least one row")
            return;
        }

        const selectedItemName = selectedRoutingOptionName;
        const selectedItemId = selectedRoutingOptionId;

        const updatedAssignedRoutingOptions = { ...assignedRoutingOptions };
        selectedRows.forEach((tn_number) => {
            updatedAssignedRoutingOptions[tn_number] = selectedRoutingOption;
        });
        setAssignedRoutingOptions(updatedAssignedRoutingOptions);

        const updatedImportNumberList = formData.importNumberList.map(item => {
            if (selectedRows.includes(item.tn_number)) {
                return {
                    ...item,
                    route_option: selectedRoutingOption,
                    route_name: selectedItemName,
                    route_id: selectedItemId
                };
            }
            return item;
        });

        setFormData({ ...formData, importNumberList: updatedImportNumberList });
    };

    const handleSave = () => {

        const newData = {
            [currentItem.tn_number]: { policy: selectedPolicy, tableData: tableData },
        };

        // Add the object to the dataArray
        const indexToUpdate = dataArray.findIndex(
            (data) => data.hasOwnProperty(currentItem.tn_number)
        );

        // If an object with the same telephone number exists, update it
        if (indexToUpdate !== -1) {
            const updatedArray = [...dataArray];
            updatedArray[indexToUpdate] = newData;
            setDataArray(updatedArray);
            setFormData({ ...formData, routePath: updatedArray });
        } else {
            // If it doesn't exist, add the new data
            setDataArray((prevDataArray) => {
                const updatedArray = [...prevDataArray, newData];
                setFormData({ ...formData, routePath: updatedArray });
                return updatedArray;
              });
        }
        setSelectedMobile(currentItem.tn_number);
        
    };
    const handleDefaultSet = () => {

        let newData;
        if(!trunkIdCount){
            const confirmed = window.confirm("Are you sure you want to apply this to all?");
            if(confirmed){
                newData = {
                    policy: selectedPolicy,
                    tableData: tableData,
                };

                const updatedArray = formData.importNumberList.map((item) => ({
                    [item.tn_number]: newData,
                }));

                // Resolve route details from tableData so the name column updates immediately
                const selectedRoutes = tableData
                    .filter((val) => val.selectedOption !== "")
                    .map((tableItem) => {
                        const selected = trunkRouteName.find((route) =>
                            route.value.includes(tableItem.selectedOption)
                        )?.name;
                        const routeDetails = routingList.find((element) => element.value === selected);
                        return routeDetails ? { value: routeDetails.value, name: routeDetails.name, id: routeDetails.id } : null;
                    })
                    .filter(Boolean);

                const route_option = selectedRoutes.map((val) => val.value).join(",");
                const route_name = selectedRoutes.map((val) => val.name).join(",");
                const route_id = selectedRoutes.map((val) => val.id).join(",");

                const updatedImportNumberList = formData.importNumberList.map((item) => ({
                    ...item,
                    route_option,
                    route_name,
                    route_id,
                }));

                setFormData({ ...formData, routePath: updatedArray, importNumberList: updatedImportNumberList });
                setDataArray(updatedArray);
                setSelectedMobile(null);
            }

        }else{
            // Single trunk - auto-assign without confirmation
            const newTableData = [...tableData];

            if (newTableData.length > 0) {
              newTableData[0].selectedOption = trunkRouteName[0].value;
              newTableData[0].inputText = '';
              newTableData[0].yesNo = '1';
            }
            newData = {
                policy: "1",
                tableData: newTableData,
            };

            const updatedArray = formData.importNumberList.map((item) => ({
                [item.tn_number]: newData,
            }));

            // Also update importNumberList with route information so it displays in the table
            const singleRoute = routingList[0]; // Since trunkIdCount is true, we have exactly 1 route
            const updatedImportNumberList = formData.importNumberList.map((item) => ({
                ...item,
                route_option: singleRoute.value,
                route_name: singleRoute.name,
                route_id: singleRoute.id,
                validTrunk: true
            }));

            setFormData({
                ...formData,
                routePath: updatedArray,
                importNumberList: updatedImportNumberList
            });
            setDataArray(updatedArray);
            setSelectedMobile(null);
        }

    }

    const handleUnassignedSet = () => {
        const confirmed = window.confirm("Are you sure you want to apply this to all Unassigen numbers?");
        if(confirmed){
            const updatedDataArray = [...dataArray];

            formData.importNumberList.forEach((item) => {
                if(!item.route_option){
                    const newData = {
                        [item.tn_number]: { policy: selectedPolicy, tableData: tableData },
                    };
                
                    const indexToUpdate = updatedDataArray.findIndex((data) =>
                        data.hasOwnProperty(item.tn_number)
                    );
                
                    if (indexToUpdate !== -1) {
                        // If the number exists in dataArray, update it
                        updatedDataArray[indexToUpdate] = newData;
                    } else {
                        // If the number doesn't exist, add it to the array
                        updatedDataArray.push(newData);
                    }
                }
                
            });

            const updatedImportNumberList = formData.importNumberList.map((item) => {
                if(!item.route_option){
                    // Extract selected routes from tableData
                    const selectedRoutes = tableData
                        .filter((val) => val.selectedOption !== "")
                        .map((tableItem) => {
                            const selected = trunkRouteName.find((route) =>
                                route.value.includes(tableItem.selectedOption)
                            )?.name;
                        
                            const routeDetails = routingList.find(
                                (element) => element.value === selected
                            );
                        
                            return routeDetails
                                ? {
                                      value: routeDetails.value,
                                      name: routeDetails.name,
                                      id: routeDetails.id,
                                  }
                                : null;
                        })
                        .filter(Boolean); // Remove null entries
                    
                    // Create combined route data
                    const route_option = selectedRoutes.map((val) => val.value).join(",");
                    const route_name = selectedRoutes.map((val) => val.name).join(",");
                    const route_id = selectedRoutes.map((val) => val.id).join(",");
                    
                    // Return updated item with new route details
                    
                    return {
                        ...item,
                        route_option,
                        route_name,
                        route_id,
                    };
                }else{
                    return {
                        ...item
                    };
                }
            });

            // Update both dataArray and formData.routePath
            setDataArray(updatedDataArray);
            setFormData({ ...formData,importNumberList: updatedImportNumberList, routePath: updatedDataArray });

            // Optionally clear the selected mobile or take another action
            setSelectedMobile(null);
        }
    }

    // trunks validation for all number
    const validateFormData = (data) => {
        const errors = [];
        console.log(data);
        // Your validation logic here
        if (!data.routePath) {
            // errors.push("Route path is missing.");
            errors.push(`Please Fill proper trunk value for all number`);
        } else {
            data.routePath.forEach(dataItem => {
                const mobileKey = Object.keys(dataItem)[0]; // Get the telephoneNumber from the object key
                const currentMobile = dataItem[mobileKey];
                if (!currentMobile) {
                    errors.push(`Mobile ${mobileKey} not found in the data.`);                
                } else {
                    if (!currentMobile.policy) {
                        errors.push(`Policy field is required for ${mobileKey}.`);            
                    }                
                    const hasTableDataValue = currentMobile.tableData.some(tableItem =>
                        tableItem.selectedOption 
                    );
                    const isValid = currentMobile.tableData.some((tableItem, index) => {
                        if (index < currentMobile.tableData.length - 1) {
                            return tableItem.selectedOption === "" && currentMobile.tableData[index + 1].selectedOption !== "";
                        }
                        return false;
                    });
                    if (!hasTableDataValue) {
                        errors.push(`Atleast one route is required for ${mobileKey}.`);
                    } else if(isValid) {
                        errors.push(`Please select proper trunk for ${mobileKey}.`);
                    }else if (currentMobile.policy === "2") {
                        const inputTextValues = currentMobile.tableData.map(tableItem => Number(tableItem.inputText));
                        const hasUserInput = inputTextValues.some(value => value > 0);    
                        if (!hasUserInput) {
                            errors.push(`Percentage values for ${mobileKey} are required.`);
                        } else {
                            const sumOfInputTextValues = inputTextValues.reduce((acc, value) => acc + value, 0);    
                            if (sumOfInputTextValues !== 100) {
                                errors.push(`Sum of percentage for ${mobileKey} is not equal to 100.`);
                            }
                        }
                    }
                }
            });
        }
    
        return errors;
    };

    const handleNext = async (e) => {
        e.preventDefault();
       
        const hasBlankRouteOption = (formData.importNumberList && formData.importNumberList.length > 0) ? formData.importNumberList.some(item => item.route_option == '') : true;
        const hasBlankRouteOptionInFormData = formData.importNumberList ? formData.importNumberList.some(item => item.route_option == '') : false;
        const errors = validateFormData(formData);
        console.log(errors);
        const bandwidthList = formData.importNumberList.filter(obj => obj.number_type == 1);
        const firstObj = bandwidthList[0];
        const areAllBandwidthRouteSame = bandwidthList.every(obj => obj.route_option == firstObj.route_option && obj.route_id == firstObj.route_id);        
        if (hasBlankRouteOptionInFormData) {            
            if (hasBlankRouteOption){
                alert("Please assign routing options for all numbers");
            }
            
        }else if(nullMessge){
            alert("There is an issue with the customer configuration which prevents ordering new numbers.  Please contact Broadband Dynamics to have this resolved.");
        }else if (errors.length > 0){
            alert(errors.join('\n'));
            // 
        }else if(!areAllBandwidthRouteSame){
            alert("Due to carrier restrictions, multiple routing options are not allowed on this order.  If you require numbers to have different routing options, please place an order for each set of numbers requiring different routing.")
        }else{
            if(formData.routePath.length != formData.importNumberList.length){
                alert("Please assign routing options for all numbers");
            }else{
                try{
                    setButtonDisabled(true);
                    setPopupOpen(true);
                    if(formData.importType === 3) {
                        axios.post(`${baseUrl}/import-upcoming-port-numbers`, formData,{
                            headers: {
                                 Authorization: `Bearer ${token}`                            
                            }
                        })
                        const allArray = { importUpcomingPort: true }
                        navigate("/order-new-number-success", { state: allArray });  
                    } else {
                        axios.post(`${baseUrl}/import-non-supported-carrier-number`, formData,{
                            headers: {
                                Authorization: `Bearer ${token}`                            
                            }
                        });
                        const allArray = {nonSupportCarrier : true}
                        navigate("/order-new-number-success", { state: allArray });  
                    }
                    setPopupOpen(false);
                    setButtonDisabled(false);
                }catch(error){
                    console.log(error)
                    setPopupOpen(false);
                    setButtonDisabled(false);
                }
               
            }
            
        }
    
    };

    

    return (
        <>
            {popupOpen && <Loader /> }
            <div className="content-sub-title">
                <div className="row">
                    <div className='order-queue'>
                        <h2>Tel Numbers and Routing Options</h2>
                        <h3>Tel Numbers: {formData.importNumberList.length}</h3>
                        {trunkIdCount && <p style={{color: '#28a745', marginTop: '10px'}}>Routing has been automatically assigned to all numbers.</p>}
                    </div>
                </div>
            </div>
            <div className="common-white-shadow-background setting-section tableinput-section">
                <div className="row footer-row">
                    <div className="footer-row-left">
                    <Link className="Back" to={"/number-management"}>Cancel</Link>
                    </div>
                    <div className="footer-row-right">
                        <a href="#" onClick={handleNext} className={buttonDisabled ? 'next disabled-link' : 'next'}>Submit</a>
                    </div>
                </div>
            </div>
            <div className="common-white-shadow-background setting-section tableinput-section">
                <div className="row">
                    <table className="tablebox new-number-two-setup">
                        <thead>
                            <tr>
                                <th>Tel Number</th>
                                {!trunkIdCount && routeSwitch == 1 && <th>Trunks</th>}
                                {!trunkIdCount && routeSwitch == 0 && <th style={{ paddingTop: "50px" }}> Select Number <input type="checkbox" className="newrow checkboxAll" onClick={handleSwitchSelectAll} checked={selectAll} /></th>}
                                {!trunkIdCount && routeSwitch == 0 && <th width="20%">Routing Option
                                    <select name="" id="" value={selectedRoutingOption}
                                     disabled={!routeOptionDisabled}
                                        onChange={(e) => {setSelectedRoutingOption(e.target.value);
                                            setSelectedRoutingOptionName(e.target.options[e.target.selectedIndex].getAttribute("data-item-name"));
                                            setSelectedRoutingOptionId(e.target.options[e.target.selectedIndex].getAttribute("data-item-value"));
                                        }}>
                                        <option value="">Select</option>
                                    {routingList.map((item, index) => (
                                    <option key={index} value={item.value} data-item-value={item.id} data-item-name={item.name}>
                                        {item.value}
                                    </option>

                                ))}

                                    </select>
                                    <a className="search" onClick={handleAssignRoutingOption} href="#">Assign Routing Option</a>
                                </th>}
                                {!trunkIdCount && routeSwitch == 1 &&<th>Route Option</th>}
                                {trunkIdCount &&<th>Route Option</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {formData.importNumberList.map((item,  index) => (
                                <tr key={index} >
                                    <td>{item.tn_number}</td>
                                    {!trunkIdCount && routeSwitch == 1 && <td >{item.validTrunk ? (<img src={`${process.env.PUBLIC_URL}/images/valid-phone.png`} onClick={() => openModal(item)} alt="Valid" />) : (<img src={`${process.env.PUBLIC_URL}/images/trunk-phone.png`} onClick={() => openModal(item)} alt="Configure" />)} </td>}
                                    {!trunkIdCount && routeSwitch == 0 && <td><input type="checkbox" name="" checked={selectedRows.includes(item.tn_number)}
                  onChange={() => handleToggleSelect(item.tn_number)} /></td>}
                                    <td><p className='green-text'>{item.route_option}</p></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <Modal 
                        isOpen={showModal}
                        onRequestClose={closeModal}
                        contentLabel={"Example Modal"}
                    >
                        <div className='row'>
                            <div className='col-sm-3 cancel-btn'><button onClick={closeModal}>Cancel</button></div>
                            <div className='col-sm-9 apply-all'>
                            {orderNumberType != 2 && formData.routePath && formData.routePath.length != 0 && formData.importNumberList && formData.routePath.length != formData.importNumberList.length &&<button className="apply-btn" onClick={handleUnassignedSet}>Apply to Unassigned</button> }
                            {orderNumberType != 2 && <button className="apply-btn" onClick={handleDefaultSet}>Apply to all</button> }
                            <button className="save-btn" onClick={handleSave} >Apply to Number</button>
                            </div>
                        </div>
                        <div className="policy">
                            <label>Policy</label>
                            <div className="switchbtn">
                                <select value={selectedPolicy} onChange={(e) => {setSelectedPolicy(e.target.value)}}>
                                    <option value="">Select Policy</option>
                                    <option value="1">top_down</option>
                                    <option value="2">percentage</option>
                                    <option value="3">round_robin</option>
                                </select>
                            </div>
                        </div>
                        {validationErrors.map((value, index) => (<p style={{"color":"red"}} key={index}>{value}</p>))}
                        <div className='fullwidth-table track-table-body staff-listing-admin-table-body'>
                        <table>
                            <thead>
                                <tr>
                                    <th>Route</th>
                                    <th>Load Percentage</th>
                                    <th>Continuous routing</th>
                                </tr>
                            </thead>
                            <tbody>
                            {tableData.map((row, index) => (
                                <tr key={index}>
                                    <td>
                                        <select value={row.selectedOption} onChange={(e) => handleRowChange(e, index, 'selectedOption')}>            
                                            <option value="" >Select Route</option>    
                                            {trunkRouteName.map((item, index) => (
                                                <option key={index} value={item.value} >
                                                  {item.name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <input type="number" value={row.inputText} onChange={(e) => handleRowChange(e, index, 'inputText')} />
                                            <span style={{ marginLeft: '5px', width: '50px', height: '25px' }}>%</span>
                                        </div>
                                    </td>
                                    <td>
                                        <select value={row.yesNo} onChange={(e) => handleRowChange(e, index, 'yesNo')}>
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>                              
                                        </select>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>
                    </Modal>
                </div>
            </div>
        </>
    )
}

export default Step2;